import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { CartType } from '~/types/services/carts';

const STATUS_DESCRIPTIONS: Record<CartType, string> = {
  [CartType.PENDING]: 'Created when the user enters the checkout page; awaiting payment.',
  [CartType.ABANDONED]: 'Left pending for 3+ hours without completion.',
  [CartType.COMPLETED]: 'User clicked "Pay now" — order submitted. The order may still fail.',
  [CartType.PURCHASED]:
    'Cart was restored into a new checkout session and a new cart was created from it. Once user clicks "Pay now", the cart is marked as purchased.',
};

export default function StatusesHeaderTooltip() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ alignSelf: 'center' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        What does status mean?
      </Typography>
      <Tooltip
        arrow
        placement="top"
        slotProps={{ tooltip: { sx: { bgcolor: 'white', color: 'black' } } }}
        title={
          <Stack spacing={1} sx={{ p: 0.5 }}>
            {Object.entries(STATUS_DESCRIPTIONS).map(([status, description]) => (
              <Box key={status}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                  {status}
                </Typography>
                <Typography variant="caption" display="block">
                  {description}
                </Typography>
              </Box>
            ))}
          </Stack>
        }
      >
        <InfoOutlinedIcon fontSize="small" sx={{ color: 'text.secondary', cursor: 'help' }} />
      </Tooltip>
    </Stack>
  );
}
